<template>
  <div class="app-container">
    <div v-if="current_user">
      <el-row :gutter="20">

        <!-- <el-col :span="6" :xs="24">
          <user-card :user="current_user" />
        </el-col> -->

        <el-col :span="12" :offset="6">
          <safe :user="current_user" />
          <!-- <el-card>
            <el-tabs v-model="activeTab">
              <el-tab-pane label="基础信息" name="account">
                <account :user="current_user" />
              </el-tab-pane>
              <el-tab-pane label="安全信息" name="safe">
                <safe :user="current_user" />
              </el-tab-pane>
            </el-tabs>
          </el-card> -->
        </el-col>

      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import UserCard from './components/UserCard'
// import Activity from './components/Activity'
// import Timeline from './components/Timeline'
// import Account from './components/Account'
import Safe from './components/Safe'

export default {
  name: 'Profile',
  components: { Safe },
  data() {
    return {
      activeTab: 'account'
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  created() {
  },
  methods: {

  }
}
</script>
